import type { ReactNode } from "react";

interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  action?: ReactNode;
}

export default function EmptyState({
  icon = "ri-inbox-line",
  title,
  description,
  action,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 px-4 rounded-lg bg-background-100 border border-dashed border-background-300">
      <span className="w-14 h-14 rounded-full bg-background-200 flex items-center justify-center mb-4">
        <i className={`${icon} text-2xl text-foreground-500`}></i>
      </span>
      <p className="text-base font-label font-bold text-foreground-800">{title}</p>
      {description && (
        <p className="text-sm text-foreground-500 mt-2 max-w-md">{description}</p>
      )}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}